import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import SingleFieldForm from '~/components/molecules/SingleFieldForm.vue';
import { fetchCustomizable } from '~/services/customizable';
import { formatPrismicImage } from '~/helpers/image-helper';
import { EMPTY_PIXEL } from '~/const/images';
export default {
  name: 'CustomizableForm',
  components: {
    SingleFieldForm: SingleFieldForm
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      value: '',
      showError: false
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    formProps: function formProps() {
      return {
        title: this.payload.primary.title[0] || {},
        paragraph: this.payload.primary.paragraph || [],
        inputLabel: this.payload.primary.input_label || '',
        errorMessage: this.payload.primary.error_message,
        buttonText: this.payload.primary.button_text || ''
      };
    },
    formattedImage: function formattedImage() {
      return "".concat(formatPrismicImage(this.payload.primary.image.url, ['w_375']), " 375w, ").concat(formatPrismicImage(this.payload.primary.image.url, ['w_375', 'dpr_1.6']), " 600w, ").concat(formatPrismicImage(this.payload.primary.image.url, ['w_1000']), " 1000w") || EMPTY_PIXEL;
    },
    formattedBgImage: function formattedBgImage() {
      return formatPrismicImage(this.payload.primary.background_image.url) || '';
    },
    trackingParams: function trackingParams() {
      return {
        data: {
          event_category: this.payload.primary.button_event_category,
          event_action: this.payload.primary.button_event_action,
          event_label: this.payload.primary.button_event_label
        }
      };
    }
  }),
  methods: {
    onSubmit: function () {
      var _onSubmit = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(value) {
        var _ref, status;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(value === '')) {
                  _context.next = 3;
                  break;
                }

                this.showError = true;
                return _context.abrupt("return");

              case 3:
                _context.next = 5;
                return fetchCustomizable(this.$store, value);

              case 5:
                _ref = _context.sent;
                status = _ref.status;

                if (status) {
                  this.$root.$emit('generic-tracking', null, this.trackingParams);
                  this.$store.app.context.redirect("/".concat(this.locale.market, "/").concat(this.locale.language, "/configurator/").concat(value));
                }

                this.showError = !status;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  }
};